import { dateStrToDate } from '../utils/datetimeUtils';

export const SORT_DIRECTIONS = {
	ASC: 'asc',
	DESC: 'desc',
};

export const VOUCHERS_PAGE_SIZE = 25;
export const ISSUE_DATE_SORT_COLUMN = 'issueDate';
export const DEFAULT_ISSUE_DATE_SORT_BY = `${ISSUE_DATE_SORT_COLUMN}:${SORT_DIRECTIONS.ASC}`;

export const createEmptyPagination = () => ({
	currentPage: 0,
	pageSize: VOUCHERS_PAGE_SIZE,
	totalItems: 0,
	totalPages: 0,
	resultStart: 0,
	resultEnd: 0,
});

const getDateOnly = (date) =>
	date && new Date(date.getFullYear(), date.getMonth(), date.getDate());

const getDownloadFilename = (contentDisposition) => {
	const filenameMatch = contentDisposition?.match(
		/filename\*?=(?:UTF-8'')?["']?([^;"']+)/i,
	);

	return filenameMatch
		? decodeURIComponent(filenameMatch[1].trim())
		: 'ouigo_refund_vouchers.csv';
};

export const downloadCsvFile = ({ buffer, contentDisposition }) => {
	const blob = new Blob([buffer], { type: 'text/csv;charset=utf-8;' });
	const url = URL.createObjectURL(blob);
	const link = document.createElement('a');

	link.href = url;
	link.download = getDownloadFilename(contentDisposition);
	document.body.appendChild(link);
	link.click();
	document.body.removeChild(link);
	URL.revokeObjectURL(url);
};

const getVoucherSortValue = (voucher, sortColumn) => {
	if (sortColumn === ISSUE_DATE_SORT_COLUMN || sortColumn === 'finalizedDate') {
		const date = dateStrToDate(voucher[sortColumn], 'dd/mm/yyyy');

		return date ? getDateOnly(date).getTime() : 0;
	}

	if (sortColumn === 'value') {
		return Number(voucher.value.replace(/[^0-9.]/g, ''));
	}

	return (voucher[sortColumn] || '').toLowerCase();
};

// Only issue date sorting is currently supported by the API. The remaining
// sortable columns are sorted locally on the vouchers returned for this page.
export const sortVouchers = (vouchers, sortColumn, sortDirection) => {
	if (!sortColumn || !sortDirection) {
		return vouchers;
	}

	return [...vouchers].sort((voucherA, voucherB) => {
		const valueA = getVoucherSortValue(voucherA, sortColumn);
		const valueB = getVoucherSortValue(voucherB, sortColumn);

		if (valueA === valueB) {
			return 0;
		}

		const sortOrder = valueA > valueB ? 1 : -1;

		return sortDirection === SORT_DIRECTIONS.ASC ? sortOrder : -sortOrder;
	});
};

export const getIssueDateSortBy = (sortColumn, sortDirection) =>
	sortColumn === ISSUE_DATE_SORT_COLUMN && sortDirection
		? `${ISSUE_DATE_SORT_COLUMN}:${sortDirection}`
		: DEFAULT_ISSUE_DATE_SORT_BY;

export const getNextSortState = (
	selectedColumn,
	currentSortColumn,
	currentSortDirection,
) => {
	if (selectedColumn !== currentSortColumn) {
		return {
			sortColumn: selectedColumn,
			sortDirection: SORT_DIRECTIONS.ASC,
		};
	}

	return {
		sortColumn: selectedColumn,
		sortDirection:
			currentSortDirection === SORT_DIRECTIONS.ASC
				? SORT_DIRECTIONS.DESC
				: SORT_DIRECTIONS.ASC,
	};
};
